import { defineComponent as _defineComponent } from 'vue'
import Navigation from "../../NavigationContainer.vue";
import { ref, onMounted, reactive, onUpdated } from "vue";
import { store } from "@/store/store";
import { useI18n } from "vue3-i18n";
import ResponseData from "@/types/ResponseData";
import NewsinfoDataService from "@/services/NewsinfoDataService";
import FAQInfoDataService from "@/services/FAQInfoDataService";
import UserInfoDataService from "@/services/UserInfoDataService";
import Loading from "@/components/home/Loading";
import Alert from "@/components/scan/parts/Alert.vue";


export default /*#__PURE__*/_defineComponent({
  setup(__props, { expose }) {
  expose();

const isLoading = ref(false);
const alertMessage = ref("null");
const alertState = ref("neutral");
const isShowing = ref(true);
const search = ref("");
const i18n = useI18n();
const newsInfo = reactive([]);
const faqInfo = reactive([]);
const searchfaqInfo = reactive([]);
const modalSubject = reactive([]);
const modalBody = reactive([]);
const getData = ref(false);
const faqMaxCount = ref(10);
const administratorAddress = ref("");

onMounted(async function () {
  isLoading.value = true;
  await Promise.all([
    getNewsAndFAQ(),
    getAdministrator()
  ]);
});

const getNewsAndFAQ = () => {
  isLoading.value = true;
  newsInfo.splice(0);
  faqInfo.splice(0);
  searchfaqInfo.splice(0);
  const data = { isShowing: isShowing.value };

  //二回目実行にアラートメッセージが表示修正
  alertMessage.value = "null";
  alertState.value = "neutral";

  // get News
  NewsinfoDataService.getNews(data)
    .then((response: ResponseData) => {
      if (response.data.length !== 0) {
        let date;
        for (let info of response.data) {
          if (info["startDate"] != null) {
            date = info["startDate"].substr(0, 10);
          }
          info["startDate"] = date;
          newsInfo.push(info);
        }
      }
      isLoading.value = false;
    })
    .catch((e: Error) => {
      console.log(e);
      alertMessage.value = i18n.t("err008");
      alertState.value = "error";
      isLoading.value = false;
    });

  // get FAQ
  FAQInfoDataService.getFAQ(data)
    .then((response: ResponseData) => {
      if (response.data.length !== 0) {
        // 2023/04/17 MDCR 修正 start
        var infoCount = 0;
        // 2023/04/17 MDCR 修正 end
        for (let info of response.data) {
          searchfaqInfo.push(info);
          // 2023/04/17 MDCR 修正 start
          if (infoCount < faqMaxCount.value) {
            faqInfo.push(info);
          }
          infoCount++;
          // 2023/04/17 MDCR 修正 end
        }
      }
      getData.value = true;
      isLoading.value = false;
    })
    .catch((e: Error) => {
      console.log(e);
      alertMessage.value = i18n.t("err009");
      alertState.value = "error";
      isLoading.value = false;
    });
};

/** プレビューボタン押下時の処理関数 */
const modalShow = (index, param) => {
  modalSubject.splice(0);
  modalBody.splice(0);
  if (param == "News") {
    for (let key of Object.keys(newsInfo)) {
      if (key == index) {
        modalSubject.push(newsInfo[key].Subject);
        var splitData = newsInfo[key].Content.split(/^/gm);
        for(let oneLine of splitData){
          modalBody.push(oneLine);
        }
        break;
      }
    }
  } else {
    for (let key of Object.keys(faqInfo)) {
      if (key == index) {
        modalSubject.push(faqInfo[key].Subject);
        modalBody.push(faqInfo[key].Content);
        break;
      }
    }
  }
};

const getAdministrator = () => {
  const data = {'userId': store.getters.cognitoUserName};
  UserInfoDataService.getAdministrator(data)
  .then((response: ResponseData) => {
    var data = response.data;
    administratorAddress.value = data.givenName + " " + data.familyName + " (" + data.email + ")";
  })
};

const showFaq = (filename: any) => {
  const data = {'filename': filename};

  FAQInfoDataService.accessToFile(data)
  .then((response: ResponseData) => {
    window.open(response.data)?.focus();
  })
};

const changeEvent = () => {
  isLoading.value = true;
  faqInfo.splice(0);
  // 2023/04/17 MDCR 修正 start
  var infoCount = 0;
  // 2023/04/17 MDCR 修正 end
  for (let info of searchfaqInfo) {
    // 2023/04/17 MDCR 修正 start
    if (
      info.Subject.toLowerCase().match(search.value.toLowerCase()) &&
      infoCount < faqMaxCount.value
    ) {
      faqInfo.push(info);
      infoCount++;
    }
    // 2023/04/17 MDCR 修正 end
  }
};

onUpdated(function () {
  isLoading.value = false;
});

const __returned__ = { isLoading, alertMessage, alertState, isShowing, search, i18n, newsInfo, faqInfo, searchfaqInfo, modalSubject, modalBody, getData, faqMaxCount, administratorAddress, getNewsAndFAQ, modalShow, getAdministrator, showFaq, changeEvent, Loading, Alert }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})